export default "__VITE_ASSET__BPa1L6iz__"